export default "__VITE_ASSET__GbT$Q1dd__"